(function() {
  'use strict';

  angular.module('ringbaPortal').component('userTaskStateDetails', {
    bindings: {
      userTaskDetails: '<',
    },
    controller: UserTaskStateDetailsController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/user-tasks/user-task-details/user-task-state-details/user-task-state-details.view.html'
  });

  function UserTaskStateDetailsController(
    $filter
  ) {
    'ngInject';

    const vm = this;

    const hideCallProperties = ['buyer Name', 'call Date', 'call ID', 'call Payout', 'call Conversion', 'publisher Name'];

    const formatFilters = {
      'call_date': _dateFilter,
      'date': _dateFilter,
      'money': _currencyFilter
    };

    vm.$onChanges = onChanges;

    function onChanges() {
      const params = _formatValues(vm.userTaskDetails.publicState);
      vm.stateValues = params.stateValuesArray;
      vm.longStateValues = params.textLongParameters;
    }

    function _formatValues(stateValues) {
      const hasCallID = !!vm.userTaskDetails.publicState['call ID'];
      const returnObj = {
        stateValuesArray: [],
        textLongParameters: []
      };
      _.forEach(stateValues, function(stateObj, key) {
        if (hasCallID && hideCallProperties.indexOf(key) > -1) {
          return;
        }

        const tempObj = _.merge({
          stateValueKey: key
        }, stateObj);
        if(formatFilters[stateObj.publicStateValueType]) {
          tempObj.displayValue = formatFilters[stateObj.publicStateValueType](stateObj.value);
        } else {
          tempObj.displayValue = stateObj.value;
        }

        if (stateObj.publicStateValueType === 'text_long') {
          returnObj.textLongParameters.push(tempObj);
        } else {
          returnObj.stateValuesArray.push(tempObj);
        }

      });

      return returnObj;
    }

    function _dateFilter(value) {
      return $filter('utcToLocal')(value, 'MMM d, y h:mm a');
    }

    function _currencyFilter(value) {
      return $filter('currency')(value, '$', 2);
    }

  }
})();
